import React from 'react'
import { useState, useEffect, useRef } from 'react';
import './ComponentsCss/AdminPageEdit.css';
// axios 
import axios from 'axios';
import useAxiosPrivate from '../hooks/useAxiosPrivate';

const AdminPageNewsEdit = () => {
  const axiosPrivate = useAxiosPrivate();
  const [AllNewsData, SetAllNewsData] = useState();
  const [NewsSel, SetNewsSel] = useState(0);

  // add new ms data 
  const [deadline, Setdeadline] = useState("");
  const [descImg, SetdescImg] = useState("");
  const [description, Setdescription] = useState("");
  const [goalSupp, SetgoalSupp] = useState("");
  const [newsId, SetnewsId] = useState("");
  const [jointNo, SetjointNo] = useState("");
  const [lawyerId, SetlawyerId] = useState("");
  const [mainImg, SetmainImg] = useState("");
  const [onGoing, SetonGoing] = useState("");
  const [suppNo, SetsuppNo] = useState("");
  const [title, Settitle] = useState("");

  const NewsMainImageRef = useRef(null);
  const NewsDescImageRef = useRef(null);
  const [AxiosNewsMainImage, setAxiosNewsMainImage] = useState();

  const changeMainImageHandler = (event) => {
    //setAxiosNewsMainImage(file);
    SetmainImg(event.target.files[0].name);
    //setAxiosNewsMainImage(event.target.files[0]);
  };
  const changeDescImageHandler = (event) => {
    //setAxiosNewsMainImage(file);
    SetdescImg(event.target.files[0].name);
    //setAxiosNewsMainImage(event.target.files[0]);
  };
  function changeImageFnc(imgSel) {
    if (imgSel == 1) {
      NewsMainImageRef.current.click();
    } else if (imgSel == 2) {
      NewsDescImageRef.current.click();
    }
  }

  useEffect(() => {
    axiosGetData();
  }, []);
  useEffect(() => {

    console.log("NewsSel sel " + NewsSel);
    if (NewsSel == -1) {
      Setdeadline("");
      SetdescImg("");
      Setdescription("");
      SetgoalSupp("");
      SetnewsId("");
      SetjointNo("");
      SetlawyerId("");
      SetmainImg("");
      SetonGoing("");
      SetsuppNo("");
      Settitle("");

    } else {
      if (AllNewsData != null && AllNewsData.length > 0) {
        Setdeadline(AllNewsData[NewsSel]?.deadline);
        SetdescImg(AllNewsData[NewsSel]?.descImg);
        Setdescription(AllNewsData[NewsSel]?.description);
        SetgoalSupp(AllNewsData[NewsSel]?.goalSupp);
        SetnewsId(AllNewsData[NewsSel]?.id);
        SetjointNo(AllNewsData[NewsSel]?.jointNo);
        SetlawyerId(AllNewsData[NewsSel]?.lawyerId);
        SetmainImg(AllNewsData[NewsSel]?.mainImg);
        SetonGoing(AllNewsData[NewsSel]?.onGoing);
        SetsuppNo(AllNewsData[NewsSel]?.suppNo);
        Settitle(AllNewsData[NewsSel]?.title);
      }

    }
  }, [NewsSel, AllNewsData]);
  const axiosGetData = async () => {
    var finalIP = "";
    // https://stepupkorea.kr/api/NewsList/getAllNews
    finalIP = "https://stepupkorea.kr/api/NewsList/getAllNews";
    try {
      const response = await axios.get(finalIP

      );
      if (response) {
        //console.log(response.data);
        SetAllNewsData(response.data);

      } else {

      }

    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Missing Username or Password');
      } else if (err.response?.status === 401) {
        console.log('--Unauthorized');
      } else {
        console.log('ERR');
      }

    }
  }
  const axiosAddNews = async () => {

    try {
      /* 
   const { deadline, descImg, description, goalSupp, jointNo, lawyerId, mainImg, onGoing, suppNo, title } = req.body;
      */
      var DataJson = "";
      DataJson = JSON.stringify({
        deadline: deadline,
        descImg: descImg,
        description: description,
        goalSupp: goalSupp,
        jointNo: jointNo,
        lawyerId: lawyerId,
        mainImg: mainImg,
        onGoing: onGoing,
        suppNo: suppNo,
        title: title

      }, null, 2);


      var finalIP = "";
      // 	"/emergency/rssi/module-status-set/<ip>"
      finalIP = "https://stepupkorea.kr/api/admin/AddNews";
      //console.log(" axiosPostModuleStatus" + finalIP);
      const response = await axiosPrivate.post(finalIP,
        DataJson,
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,

        }
      );
      if (response) {
        console.log(" Add news success !");
        axiosGetData();
      }
    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Username and password are required.');

      } else if (err.response?.status === 401) {
        console.log('-- Wrong conf password ');

      }
      else if (err.response?.status === 402) {
        console.log('-- Username already exists ');

      } else {
        console.log('ERR');
      }

    }
  }
  const axiosUpdateNews = async () => {

    try {
      /* 
        const { newsId, deadline, descImg, description, goalSupp, id, jointNo, lawyerId, mainImg, onGoing, suppNo, title } = req.body;

      */
      var DataJson = "";
      DataJson = JSON.stringify({
        newsId, newsId,
        deadline: deadline,
        descImg: descImg,
        description: description,
        goalSupp: goalSupp,
        jointNo: jointNo,
        lawyerId: lawyerId,
        mainImg: mainImg,
        onGoing: onGoing,
        suppNo: suppNo,
        title: title

      }, null, 2);


      var finalIP = "";
      // 	"/emergency/rssi/module-status-set/<ip>"
      finalIP = "https://stepupkorea.kr/api/admin/UpdateNews";
      //console.log(" axiosPostModuleStatus" + finalIP);
      const response = await axiosPrivate.post(finalIP,
        DataJson,
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,

        }
      );
      if (response) {
        console.log(" Update ms success !");
        axiosGetData();
      }
    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Username and password are required.');

      } else if (err.response?.status === 401) {
        console.log('-- Wrong conf password ');

      }
      else if (err.response?.status === 402) {
        console.log('-- Username already exists ');

      } else {
        console.log('ERR');
      }

    }
  }
  const axiosUploadImage = async () => {

    const formData = new FormData();
    formData.append('my-image-file', AxiosNewsMainImage);

    let formObject = Object.fromEntries(formData.entries());
    console.log(formObject);
    if (AxiosNewsMainImage != null) {
      try {


        var finalIP = "";

        // 	"/emergency/rssi/module-status-set/<ip>"
        finalIP = "https://stepupkorea.kr/api/newslist-main-image-upload";
        //console.log(" axiosPostModuleStatus" + finalIP);
        const response = await axiosPrivate.post(finalIP,
          formData
        );
        if (response) {
          console.log(" Update iamge success !");
          axiosGetData();
        }
      } catch (err) {

        if (!err?.response) {
          console.log('--No Server Response');
        } else if (err.response?.status === 400) {
          console.log('--Username and password are required.');

        } else if (err.response?.status === 401) {
          console.log('-- Wrong conf password ');

        }
        else if (err.response?.status === 402) {
          console.log('-- Username already exists ');

        } else {
          console.log('ERR');
        }

      }
    } else {
      console.log(" AxiosNewsMainImage is NULL ")
    }

  }



  return (
    <div className='admin-page-edit-main'>
      <div className='admin-page-edit-list'>

        {
          AllNewsData != null && AllNewsData.length > 0 ?
            AllNewsData.map((news, index) => (
              <div className='admin-page-list-button' onClick={() => SetNewsSel(index)}>{news.id} : {news.title} </div>


            ))
            : null
        }
        <div className='admin-page-list-button' onClick={() => SetNewsSel(-1)}  > + 사건 추가 </div>


      </div>
      <div className='admin-page-edit-details'>

        {
          NewsSel == -1 ?
            <>

              <br />
              <div className='admin-page-title-text'> 담당변호사: </div>
              <input className='admin-page-input' value={lawyerId} onInput={(e) => SetlawyerId(e.target.value)} />



              <div className='admin-page-title-text'> 제목: </div>
              <input className='admin-page-input' value={title} onInput={(e) => Settitle(e.target.value)} />


              <div className='admin-page-title-text'> 설명: </div>
              <textarea className='admin-page-input' rows={8} cols={60} value={description} onInput={(e) => Setdescription(e.target.value)} />
              <div className='admin-page-title-text'> 게시판 이미지: </div>

              <div className='admin-page-list-button' onClick={() => changeImageFnc(1)}> 파일 선택 </div>
              <input type="file" name="input1" ref={NewsMainImageRef} style={{ display: 'none' }}
                onChange={changeMainImageHandler} />

              <input className='admin-page-input' value={mainImg} />


              <div className='admin-page-title-text'> 설명 이미지: </div>
              <div className='admin-page-list-button' onClick={() => changeImageFnc(2)}> 파일 선택 </div>
              <input type="file" name="input1" ref={NewsDescImageRef} style={{ display: 'none' }}
                onChange={changeDescImageHandler} />
              <input className='admin-page-input' value={descImg} />
              <br />

              <div className='admin-page-title-text'> 진행중 : </div>
              <input className='admin-page-input' type='number' value={onGoing} onInput={(e) => SetonGoing(e.target.value)} />
              <div className='admin-page-title-text'> 최종날짜: </div>
              <input className='admin-page-input' value={deadline} onInput={(e) => Setdeadline(e.target.value)} />

              <div className='admin-page-title-text'> 목표인원: </div>
              <input className='admin-page-input' type='number' value={goalSupp} onInput={(e) => SetgoalSupp(e.target.value)} />
              <div className='admin-page-title-text'> 공동 고발 인원: </div>
              <input className='admin-page-input' type='number' value={jointNo} onInput={(e) => SetjointNo(e.target.value)} />
              <div className='admin-page-title-text'> 응원 인원: </div>
              <input className='admin-page-input' type='number' value={suppNo} onInput={(e) => SetsuppNo(e.target.value)} />


              <br />
              <br />
              <div className='admin-page-list-button' onClick={() => axiosAddNews()}> 사건 추가 +  </div>

              <br />
              <br />

            </>
            :
            AllNewsData != null && AllNewsData.length > 0 && NewsSel != -1 ?
              <>
                <div className='admin-page-title-text'> ID:  {newsId} </div>
                <br />
                <div className='admin-page-title-text'> 담당변호사: </div>
                <input className='admin-page-input' value={lawyerId} onInput={(e) => SetlawyerId(e.target.value)} />



                <div className='admin-page-title-text'> 제목: </div>
                <input className='admin-page-input' value={title} onInput={(e) => Settitle(e.target.value)} />


                <div className='admin-page-title-text'> 설명: </div>
                <textarea className='admin-page-input' rows={8} cols={60} value={description} onInput={(e) => Setdescription(e.target.value)} />
                <div className='admin-page-title-text'> 게시판 이미지: </div>
                <div className='admin-page-list-button' onClick={() => changeImageFnc(1)}> 파일 선택 </div>


                <input type="file" name="input1" ref={NewsMainImageRef} style={{ display: 'none' }}
                  onChange={changeMainImageHandler} />

                <input className='admin-page-input' value={mainImg} />


                <div className='admin-page-title-text'> 설명 이미지: </div>
                <div className='admin-page-list-button' onClick={() => changeImageFnc(2)}> 파일 선택 </div>


                <input type="file" name="input1" ref={NewsDescImageRef} style={{ display: 'none' }}
                  onChange={changeDescImageHandler} />
                <input className='admin-page-input' value={descImg} />

                <br />

                <div className='admin-page-title-text'> 진행중 : </div>
                <input className='admin-page-input' value={onGoing} onInput={(e) => SetonGoing(e.target.value)} />
                <div className='admin-page-title-text'> 최종날짜: </div>
                <input className='admin-page-input' value={deadline} onInput={(e) => Setdeadline(e.target.value)} />

                <div className='admin-page-title-text'> 목표인원: </div>
                <input className='admin-page-input' value={goalSupp} onInput={(e) => SetgoalSupp(e.target.value)} />
                <div className='admin-page-title-text'> 공동 고발 인원: </div>
                <input className='admin-page-input' value={jointNo} onInput={(e) => SetjointNo(e.target.value)} />
                <div className='admin-page-title-text'> 응원 인원: </div>
                <input className='admin-page-input' value={suppNo} onInput={(e) => SetsuppNo(e.target.value)} />


                <br />
                <br />
                <div className='admin-page-list-button' onClick={() => axiosUpdateNews()}> 정보 업데이트 </div>

                <br />
                <br />



              </>
              : null
        }




      </div>

    </div>
  )
}
/* 
deadline
 
descImg

description
 
goalSupp
목표인원 
 
id
 
jointNo
 공동 고발 인원 

lawyerId
 
mainImg

onGoing
진행중  
suppNo
 응원 인원 

title
 
*/

export default AdminPageNewsEdit